import { useEffect, useRef } from 'react'
import ReactQuill from 'react-quill' // ES6
import classNames from 'classnames'

import 'react-quill/dist/quill.snow.css'
import style from './style.scss'

type Props = {
  className?: string
  inputId?: string
  label?: string
  placeholder?: string
  readOnly?: boolean
  updateField?: (text: string) => void
  value: string
}

export const editingModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link'],
    ['clean'],
  ],
}

const noEditModules = {
  toolbar: null,
}

export const formats = [
  'blockquote',
  'bold',
  'bullet',
  'indent',
  'italic',
  'link',
  'list',
  'strike',
  'underline',
]

RichText.defaultProps = {
  className: '',
  inputId: undefined,
  readOnly: false,
}

function RichText(props: Props) {
  const {
    className,
    inputId,
    label,
    placeholder,
    readOnly,
    updateField,
    value,
  } = props

  const handleUpdate = (val: string) => {
    if (updateField) {
      updateField(val)
    }
  }

  const editor = useRef<ReactQuill | null>(null)

  useEffect(() => {
    if (editor.current && !readOnly) {
      editor.current.focus()
    }
  }, [editor, readOnly])

  return (
    <div
      aria-label={label}
      className={classNames(
        style.wrapper,
        { [style.readOnly]: readOnly },
        className,
      )}
    >
      <ReactQuill
        ref={editor}
        formats={formats}
        id={inputId}
        modules={readOnly ? noEditModules : editingModules}
        placeholder={placeholder}
        preserveWhitespace
        readOnly={readOnly}
        value={value}
        onChange={handleUpdate}
      />
    </div>
  )
}

export default RichText
